import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const SettingsPlaceholderPanel = ({ icon: Icon, label, description }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        flex: 1,
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          bgcolor: theme.palette.primary.main,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        {Icon && <Icon style={{ color: "#fff", fontSize: 22 }} />}
      </Box>
      <Typography
        variant="body"
        sx={{ fontWeight: 700, color: theme.palette.text.primary, mb: 1 }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.secondary, mb: 3, maxWidth: 480 }}
      >
        {description}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.disabled, fontStyle: "italic" }}
      >
        This section is coming soon.
      </Typography>
    </Paper>
  );
};

export default SettingsPlaceholderPanel;
